import { render, staticRenderFns } from "./AttributeForm.vue?vue&type=template&id=633baddc&scoped=true&"
import script from "./AttributeForm.vue?vue&type=script&lang=js&"
export * from "./AttributeForm.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/attribute/AttributeForm/AttributeFormStyle.css?vue&type=style&index=0&id=633baddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633baddc",
  null
  
)

export default component.exports